import {useMutation} from '@apollo/react-hooks';

import type {
    MeetingUpdateInput,
    UpdateMeeting as UpdateMeetingMutation,
    UpdateMeetingVariables as UpdateMeetingMutationVariables,
} from 'nutshell-graphql-types';

import UPDATE_MEETING from '../mutations/update-meeting.graphql';

export function useHideMeeting(): (arg1: MeetingUpdateInput) => Promise<any> {
    const [updateMeeting] = useMutation<UpdateMeetingMutation, UpdateMeetingMutationVariables>(
        UPDATE_MEETING
    );

    return (updateInput: MeetingUpdateInput) => {
        return updateMeeting({
            variables: {input: updateInput},
        });
    };
}
